import React from 'react';
import Tabs from '../../components/tabs';
import BonusPersonalIssueList from '../list';
import CreateBonusPersonal from '../create';
import HistoryBonusPersonal from '../history';
import {useStyles} from './helpers';

const View = () => {
    const classes = useStyles();
    const [step, setStep] = React.useState(1);
    const [activeTab, setActiveTab] = React.useState('gamer');
    const [selectId, setSelectId] = React.useState([]);
    const [search, setSearch] = React.useState('');
    
    return (
        <div className={classes.wrap}>
            {
                step === 1 &&
                <>
                    <Tabs 
                        setActiveTab={setActiveTab} 
                        setSearch={setSearch} 
                        search={search}
                        activeTab={activeTab} 
                       
                    />
                    {
                        activeTab === 'gamer' &&
                        <BonusPersonalIssueList search={search} setStep={setStep} selectId={selectId} setSelectId={setSelectId} />
                    }
                    {
                        activeTab === 'history' &&
                        <HistoryBonusPersonal search={search} setStep={setStep} selectId={selectId} setSelectId={setSelectId} />
                    }
                </>
            }
            {
                step === 2 &&
                <>
                    <CreateBonusPersonal selectId={selectId} setStep={setStep} setSelectId={setSelectId}/>
                </>
            }
        </div>
    )
}

export default View;